import {TFunction} from 'i18next'

export enum FeaturedRookiesErrors {
    FeaturedRookiesNotFound = 'FeaturedRookiesNotFound',
    FeaturedRookiesLimit = 'FeaturedRookiesLimit',
    FeaturedRookieAlreadyExists = 'FeaturedRookieAlreadyExists',
    FeaturedRookieCannotBeYourself = 'FeaturedRookieCannotBeYourself'
}

export const getErrorMessage = (errorCode: FeaturedRookiesErrors, t: TFunction<'translation', undefined>) => {
    switch (errorCode) {
        case FeaturedRookiesErrors.FeaturedRookiesNotFound:
            return t('validation:featured_hosts_errors:featured_rookies_not_found')

        case FeaturedRookiesErrors.FeaturedRookiesLimit:
            return t('validation:featured_hosts_errors:featured_rookies_limit')

        case FeaturedRookiesErrors.FeaturedRookieAlreadyExists:
            return t('validation:featured_hosts_errors:featured_rookie_already_exists')

        case FeaturedRookiesErrors.FeaturedRookieCannotBeYourself:
            return t('validation:featured_hosts_errors:featured_rookie_cannot_be_yourself')

        default:
            return t('validation:unknown_error')
    }
}
